export namespace CurrentUserActions {
    export class Get {
        public static readonly type = "[CurrentUser] Get";
    }
}
